import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CanonicalEntityList } from '@/components/knowledge/CanonicalEntityList';
import { CanonicalEntityDetail } from '@/components/knowledge/CanonicalEntityDetail';
import { ResolutionStats } from '@/components/knowledge/ResolutionStats';
import { useKnowledgeStore } from '@/stores/knowledge';

export function KnowledgeManagementPage() {
  const { canonicalId } = useParams<{ canonicalId?: string }>();
  const { fetchCanonicalDetail } = useKnowledgeStore();

  useEffect(() => {
    if (canonicalId) {
      fetchCanonicalDetail(canonicalId);
    }
  }, [canonicalId, fetchCanonicalDetail]);

  return (
    <div className="flex flex-col h-full bg-slate-50">
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
        <div>
          <h1 className="text-xl font-semibold text-navy-900">Knowledge Management</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Canonical entities from semantic entity resolution
          </p>
        </div>
      </div>

      {/* Three-panel layout */}
      <div className="flex flex-1 min-h-0">
        {/* Left panel: entity list */}
        <div className="w-72 flex-shrink-0">
          <CanonicalEntityList />
        </div>

        {/* Main panel: detail / graph */}
        <div className="flex-1 min-w-0 bg-white">
          <CanonicalEntityDetail />
        </div>
      </div>

      {/* Bottom stats bar */}
      <ResolutionStats />
    </div>
  );
}
